import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import appConfig from '../../config/appConfig';

const StatusBar = () => {
  const { user, isAuthenticated } = useAuth();
  const [status, setStatus] = useState('Ready');
  const [time, setTime] = useState(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
  const [visitCount, setVisitCount] = useState(0);
  const [releaseVersion, setReleaseVersion] = useState('1.0.0');

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    fetch(`${appConfig.apiBaseUrl}/meta`, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load release metadata');
        return response.json();
      })
      .then((metadata) => {
        if (metadata?.release_version) setReleaseVersion(metadata.release_version);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          // Keep the fallback version while the backend is unavailable.
        }
      });

    return () => controller.abort();
  }, []);

  useEffect(() => {
    // Local (device) visit counter so UI has a stable value without backend changes.
    try {
      const key = 'rayat_visit_count';
      const raw = localStorage.getItem(key);
      const next = Math.max(0, Number(raw || 0)) + 1;
      localStorage.setItem(key, String(next));
      setVisitCount(next);
    } catch {
      setVisitCount(0);
    }
  }, []);

  const userName = user?.name || 'Guest';
  const displayName = userName.length > 10 ? `${userName.substring(0, 8)}...` : userName;

  return (
    <div
      className="status-bar px-3 text-[11px] flex justify-between items-center border-t font-semibold"
      style={{
        height: 28,
        background: '#007acc',
        color: '#ffffff',
        borderColor: 'rgba(255,255,255,0.18)',
      }}
    >
      <div className="flex items-center gap-3 overflow-hidden">
        <span className="opacity-90 whitespace-nowrap">Visitors: {visitCount}</span>
        <span className="opacity-90 truncate">{status}</span>
        {isAuthenticated && (
          <span
            className="px-2 py-0.5 rounded text-[11px] truncate max-w-[140px]"
            style={{ background: 'rgba(0,0,0,0.22)' }}
            title={userName}
          >
            {displayName}
          </span>
        )}
      </div>
      <div className="flex items-center gap-3">
        <span
          className="px-2 py-0.5 rounded text-[11px]"
          style={{ background: 'rgba(0,0,0,0.22)' }}
        >
          v{releaseVersion}
        </span>
        <span className="opacity-90 whitespace-nowrap">{time}</span>
      </div>
    </div>
  );
};

export default StatusBar;
